var map = {
	"./1855": 211,
	"./1855.png": 211,
	"./222": 212,
	"./222.png": 212,
	"./about/bg-cta": 213,
	"./about/bg-cta.png": 213,
	"./about/bg-story": 214,
	"./about/bg-story.png": 214,
	"./about/bg-vision": 215,
	"./about/bg-vision.png": 215,
	"./about/person/jon": 44,
	"./about/person/jon.png": 44,
	"./about/person/jon.webp": 880,
	"./about/person/putra": 45,
	"./about/person/putra.png": 45,
	"./about/person/putra.webp": 881,
	"./about/person/ric": 46,
	"./about/person/ric.png": 46,
	"./about/person/ric.webp": 882,
	"./about/person/suren": 47,
	"./about/person/suren.png": 47,
	"./about/person/suren.webp": 883,
	"./about/person/yunita": 48,
	"./about/person/yunita.png": 48,
	"./about/person/yunita.webp": 884,
	"./about/social/blogger": 216,
	"./about/social/blogger.png": 216,
	"./about/social/email": 217,
	"./about/social/email.png": 217,
	"./about/social/facebook": 218,
	"./about/social/facebook.png": 218,
	"./about/social/instagram": 219,
	"./about/social/instagram.png": 219,
	"./about/social/linkedin": 220,
	"./about/social/linkedin.png": 220,
	"./about/social/pinterest": 221,
	"./about/social/pinterest.png": 221,
	"./about/social/youtube": 222,
	"./about/social/youtube.png": 222,
	"./about/world-map": 223,
	"./about/world-map.png": 223,
	"./amara": 224,
	"./amara.png": 224,
	"./apple-icon": 225,
	"./apple-icon.png": 225,
	"./arrow-down-icon": 226,
	"./arrow-down-icon.png": 226,
	"./attch": 227,
	"./attch.png": 227,
	"./avatar": 228,
	"./avatar.jpg": 228,
	"./banner/onboarding": 229,
	"./banner/onboarding.png": 229,
	"./banner/supervenue": 230,
	"./banner/supervenue.png": 230,
	"./bg-card": 231,
	"./bg-card.png": 231,
	"./bg-contact": 232,
	"./bg-contact.png": 232,
	"./bg-criteria": 233,
	"./bg-criteria.png": 233,
	"./bg-half": 234,
	"./bg-half.png": 234,
	"./calendar/arrow-right": 235,
	"./calendar/arrow-right.png": 235,
	"./calendar/calendar-check": 236,
	"./calendar/calendar-check.png": 236,
	"./calendar/change": 237,
	"./calendar/change.png": 237,
	"./calendar/google": 238,
	"./calendar/google.png": 238,
	"./calendar/outlook": 239,
	"./calendar/outlook.png": 239,
	"./down-icon": 240,
	"./down-icon-blue": 241,
	"./down-icon-blue.svg": 241,
	"./down-icon.svg": 240,
	"./facebook-icon": 242,
	"./facebook-icon.png": 242,
	"./favicon": 243,
	"./favicon.png": 243,
	"./filter-icon": 244,
	"./filter-icon.png": 244,
	"./frontend_application/Balon": 245,
	"./frontend_application/Balon.svg": 245,
	"./frontend_application/Bannerdesktop": 246,
	"./frontend_application/Bannerdesktop.png": 246,
	"./frontend_application/Bannermobile": 247,
	"./frontend_application/Bannermobile.png": 247,
	"./frontend_application/Bannertablet": 248,
	"./frontend_application/Bannertablet.png": 248,
	"./frontend_application/bank-placeholder": 249,
	"./frontend_application/bank-placeholder.svg": 249,
	"./frontend_application/banner-enquiry-ebook": 250,
	"./frontend_application/banner-enquiry-ebook.png": 250,
	"./frontend_application/banner-home": 49,
	"./frontend_application/banner-home.jpg": 49,
	"./frontend_application/banner-home.webp": 885,
	"./frontend_application/banner-miceneurol": 251,
	"./frontend_application/banner-miceneurol-2": 252,
	"./frontend_application/banner-miceneurol-2.png": 252,
	"./frontend_application/banner-miceneurol.png": 251,
	"./frontend_application/banner-onboard": 253,
	"./frontend_application/banner-onboard.png": 253,
	"./frontend_application/banner-post-enquiry": 254,
	"./frontend_application/banner-post-enquiry.png": 254,
	"./frontend_application/banner-sgbrideonthehunt-ipad": 255,
	"./frontend_application/banner-sgbrideonthehunt-ipad.png": 255,
	"./frontend_application/banner-sgbrideonthehunt-md": 256,
	"./frontend_application/banner-sgbrideonthehunt-md.png": 256,
	"./frontend_application/banner-sgbrideonthehunt-sm": 257,
	"./frontend_application/banner-sgbrideonthehunt-sm.png": 257,
	"./frontend_application/banner-sgbrideonthehunt-tablet": 258,
	"./frontend_application/banner-sgbrideonthehunt-tablet.png": 258,
	"./frontend_application/banner-sgbrideonthehunt2-md": 259,
	"./frontend_application/banner-sgbrideonthehunt2-md.png": 259,
	"./frontend_application/banner-sgbrideonthehunt2-sm": 260,
	"./frontend_application/banner-sgbrideonthehunt2-sm.png": 260,
	"./frontend_application/banner-upgrade": 261,
	"./frontend_application/banner-upgrade.png": 261,
	"./frontend_application/banner/eo-outside-sg/desktop": 262,
	"./frontend_application/banner/eo-outside-sg/desktop.png": 262,
	"./frontend_application/banner/eo-outside-sg/mobile": 263,
	"./frontend_application/banner/eo-outside-sg/mobile.png": 263,
	"./frontend_application/banner/eo-outside-sg/tab": 264,
	"./frontend_application/banner/eo-outside-sg/tab.png": 264,
	"./frontend_application/banner/eo-sg/desktop": 265,
	"./frontend_application/banner/eo-sg/desktop.png": 265,
	"./frontend_application/banner/eo-sg/mobile": 266,
	"./frontend_application/banner/eo-sg/mobile.png": 266,
	"./frontend_application/banner/eo-sg/tab": 267,
	"./frontend_application/banner/eo-sg/tab.png": 267,
	"./frontend_application/banner/free-outside-sg/desktop": 268,
	"./frontend_application/banner/free-outside-sg/desktop.png": 268,
	"./frontend_application/banner/free-outside-sg/mobile": 269,
	"./frontend_application/banner/free-outside-sg/mobile.png": 269,
	"./frontend_application/banner/free-outside-sg/tab": 270,
	"./frontend_application/banner/free-outside-sg/tab.png": 270,
	"./frontend_application/banner/free-sg/desktop": 271,
	"./frontend_application/banner/free-sg/desktop.png": 271,
	"./frontend_application/banner/free-sg/mobile": 272,
	"./frontend_application/banner/free-sg/mobile.png": 272,
	"./frontend_application/banner/free-sg/tab": 273,
	"./frontend_application/banner/free-sg/tab.png": 273,
	"./frontend_application/banner_emerge_venuerific_2022": 274,
	"./frontend_application/banner_emerge_venuerific_2022.png": 274,
	"./frontend_application/banner_get_more": 275,
	"./frontend_application/banner_get_more.jpg": 275,
	"./frontend_application/bell": 276,
	"./frontend_application/bell.png": 276,
	"./frontend_application/bg-upgrade": 277,
	"./frontend_application/bg-upgrade-text": 278,
	"./frontend_application/bg-upgrade-text-ipad": 279,
	"./frontend_application/bg-upgrade-text-ipad.png": 279,
	"./frontend_application/bg-upgrade-text-mobile": 280,
	"./frontend_application/bg-upgrade-text-mobile.png": 280,
	"./frontend_application/bg-upgrade-text.png": 278,
	"./frontend_application/bg-upgrade.png": 277,
	"./frontend_application/booking-banner": 281,
	"./frontend_application/booking-banner.jpg": 281,
	"./frontend_application/bottomnav/favourite": 282,
	"./frontend_application/bottomnav/favourite.svg": 282,
	"./frontend_application/bottomnav/marker": 283,
	"./frontend_application/bottomnav/marker.svg": 283,
	"./frontend_application/bottomnav/notification": 284,
	"./frontend_application/bottomnav/notification.svg": 284,
	"./frontend_application/bottomnav/profile": 285,
	"./frontend_application/bottomnav/profile.svg": 285,
	"./frontend_application/bottomnav/search": 286,
	"./frontend_application/bottomnav/search.svg": 286,
	"./frontend_application/bulb": 287,
	"./frontend_application/bulb.png": 287,
	"./frontend_application/celebrate-icon": 288,
	"./frontend_application/celebrate-icon.png": 288,
	"./frontend_application/christmas/bg-bottom": 289,
	"./frontend_application/christmas/bg-bottom.jpg": 289,
	"./frontend_application/christmas/bg-top": 290,
	"./frontend_application/christmas/bg-top.png": 290,
	"./frontend_application/christmas/bottom-decoration": 291,
	"./frontend_application/christmas/bottom-decoration.png": 291,
	"./frontend_application/christmas/boxes": 292,
	"./frontend_application/christmas/boxes.png": 292,
	"./frontend_application/christmas/campaign-one": 293,
	"./frontend_application/christmas/campaign-one.png": 293,
	"./frontend_application/christmas/campaign-three": 294,
	"./frontend_application/christmas/campaign-three.png": 294,
	"./frontend_application/christmas/campaign-two": 295,
	"./frontend_application/christmas/campaign-two.png": 295,
	"./frontend_application/christmas/candy-icon": 296,
	"./frontend_application/christmas/candy-icon.png": 296,
	"./frontend_application/christmas/candy-one": 297,
	"./frontend_application/christmas/candy-one.png": 297,
	"./frontend_application/christmas/candy-two": 298,
	"./frontend_application/christmas/candy-two.png": 298,
	"./frontend_application/christmas/christmas_desktop": 299,
	"./frontend_application/christmas/christmas_desktop.png": 299,
	"./frontend_application/christmas/christmas_mobile": 300,
	"./frontend_application/christmas/christmas_mobile.png": 300,
	"./frontend_application/christmas/fortune-wheel": 301,
	"./frontend_application/christmas/fortune-wheel.png": 301,
	"./frontend_application/christmas/partner-five": 302,
	"./frontend_application/christmas/partner-five.png": 302,
	"./frontend_application/christmas/partner-four": 303,
	"./frontend_application/christmas/partner-four.png": 303,
	"./frontend_application/christmas/partner-one": 304,
	"./frontend_application/christmas/partner-one.png": 304,
	"./frontend_application/christmas/partner-three": 305,
	"./frontend_application/christmas/partner-three.png": 305,
	"./frontend_application/christmas/partner-two": 306,
	"./frontend_application/christmas/partner-two.png": 306,
	"./frontend_application/christmas/play-background": 307,
	"./frontend_application/christmas/play-background.png": 307,
	"./frontend_application/christmas/play-logo": 308,
	"./frontend_application/christmas/play-logo.png": 308,
	"./frontend_application/christmas/star-icon": 309,
	"./frontend_application/christmas/star-icon.png": 309,
	"./frontend_application/christmas/top-decoration": 310,
	"./frontend_application/christmas/top-decoration.png": 310,
	"./frontend_application/christmas/wheel-icon": 311,
	"./frontend_application/christmas/wheel-icon.png": 311,
	"./frontend_application/content_production/Ray-Ban": 312,
	"./frontend_application/content_production/Ray-Ban.png": 312,
	"./frontend_application/content_production/bg_bottom": 313,
	"./frontend_application/content_production/bg_bottom.png": 313,
	"./frontend_application/content_production/bg_testi": 314,
	"./frontend_application/content_production/bg_testi.png": 314,
	"./frontend_application/content_production/bg_top": 315,
	"./frontend_application/content_production/bg_top.png": 315,
	"./frontend_application/content_production/client_1": 316,
	"./frontend_application/content_production/client_1.png": 316,
	"./frontend_application/content_production/client_10": 317,
	"./frontend_application/content_production/client_10.png": 317,
	"./frontend_application/content_production/client_11": 318,
	"./frontend_application/content_production/client_11.png": 318,
	"./frontend_application/content_production/client_12": 319,
	"./frontend_application/content_production/client_12.png": 319,
	"./frontend_application/content_production/client_13": 320,
	"./frontend_application/content_production/client_13.png": 320,
	"./frontend_application/content_production/client_14": 321,
	"./frontend_application/content_production/client_14.png": 321,
	"./frontend_application/content_production/client_2": 322,
	"./frontend_application/content_production/client_2.png": 322,
	"./frontend_application/content_production/client_3": 323,
	"./frontend_application/content_production/client_3.png": 323,
	"./frontend_application/content_production/client_4": 324,
	"./frontend_application/content_production/client_4.png": 324,
	"./frontend_application/content_production/client_5": 325,
	"./frontend_application/content_production/client_5.png": 325,
	"./frontend_application/content_production/client_6": 326,
	"./frontend_application/content_production/client_6.png": 326,
	"./frontend_application/content_production/client_7": 327,
	"./frontend_application/content_production/client_7.png": 327,
	"./frontend_application/content_production/client_8": 328,
	"./frontend_application/content_production/client_8.png": 328,
	"./frontend_application/content_production/client_9": 329,
	"./frontend_application/content_production/client_9.png": 329,
	"./frontend_application/content_production/client_six": 330,
	"./frontend_application/content_production/client_six.png": 330,
	"./frontend_application/content_production/image": 331,
	"./frontend_application/content_production/image.png": 331,
	"./frontend_application/content_production/other_service_one": 332,
	"./frontend_application/content_production/other_service_one.png": 332,
	"./frontend_application/content_production/other_service_three": 333,
	"./frontend_application/content_production/other_service_three.png": 333,
	"./frontend_application/content_production/other_service_two": 334,
	"./frontend_application/content_production/other_service_two.png": 334,
	"./frontend_application/content_production/service_img": 335,
	"./frontend_application/content_production/service_img.png": 335,
	"./frontend_application/content_production/top_service_one": 336,
	"./frontend_application/content_production/top_service_one.png": 336,
	"./frontend_application/content_production/top_service_three": 337,
	"./frontend_application/content_production/top_service_three.png": 337,
	"./frontend_application/content_production/top_service_two": 338,
	"./frontend_application/content_production/top_service_two.png": 338,
	"./frontend_application/content_production/user_one": 339,
	"./frontend_application/content_production/user_one.png": 339,
	"./frontend_application/content_production/user_three": 340,
	"./frontend_application/content_production/user_three.jpeg": 340,
	"./frontend_application/content_production/user_two": 341,
	"./frontend_application/content_production/user_two.png": 341,
	"./frontend_application/controls": 342,
	"./frontend_application/controls.png": 342,
	"./frontend_application/country/hk": 343,
	"./frontend_application/country/hk.jpg": 343,
	"./frontend_application/country/id": 344,
	"./frontend_application/country/id.jpg": 344,
	"./frontend_application/country/my": 345,
	"./frontend_application/country/my.jpg": 345,
	"./frontend_application/country/ph": 346,
	"./frontend_application/country/ph.jpg": 346,
	"./frontend_application/country/sg": 347,
	"./frontend_application/country/sg.jpg": 347,
	"./frontend_application/country/th": 348,
	"./frontend_application/country/th.jpg": 348,
	"./frontend_application/coupon-blue": 349,
	"./frontend_application/coupon-blue.png": 349,
	"./frontend_application/coupon-green": 350,
	"./frontend_application/coupon-green.png": 350,
	"./frontend_application/coupon-orange": 351,
	"./frontend_application/coupon-orange.png": 351,
	"./frontend_application/coupon-purple": 352,
	"./frontend_application/coupon-purple.png": 352,
	"./frontend_application/coupon-red": 353,
	"./frontend_application/coupon-red.png": 353,
	"./frontend_application/data-deals-icon": 354,
	"./frontend_application/data-deals-icon.png": 354,
	"./frontend_application/delete-icon": 355,
	"./frontend_application/delete-icon.png": 355,
	"./frontend_application/document-blank": 356,
	"./frontend_application/document-blank.png": 356,
	"./frontend_application/down-icon": 357,
	"./frontend_application/down-icon.svg": 357,
	"./frontend_application/edit-icon": 358,
	"./frontend_application/edit-icon.png": 358,
	"./frontend_application/eventtype/baby": 359,
	"./frontend_application/eventtype/baby.jpg": 359,
	"./frontend_application/eventtype/birthday": 360,
	"./frontend_application/eventtype/birthday.jpg": 360,
	"./frontend_application/eventtype/dinner": 361,
	"./frontend_application/eventtype/dinner.jpg": 361,
	"./frontend_application/eventtype/dnd": 362,
	"./frontend_application/eventtype/dnd.jpg": 362,
	"./frontend_application/eventtype/meeting": 363,
	"./frontend_application/eventtype/meeting.jpg": 363,
	"./frontend_application/eventtype/seminar": 364,
	"./frontend_application/eventtype/seminar.jpg": 364,
	"./frontend_application/eventtype/wedding": 365,
	"./frontend_application/eventtype/wedding.jpg": 365,
	"./frontend_application/fast-enquiry-bg": 366,
	"./frontend_application/fast-enquiry-bg.jpg": 366,
	"./frontend_application/fast-enquiry-btn-icon": 367,
	"./frontend_application/fast-enquiry-btn-icon.png": 367,
	"./frontend_application/fast-enquiry-icon": 368,
	"./frontend_application/fast-enquiry-icon.png": 368,
	"./frontend_application/favicon-196x196": 369,
	"./frontend_application/favicon-196x196.png": 369,
	"./frontend_application/filter-icon": 370,
	"./frontend_application/filter-icon.png": 370,
	"./frontend_application/footericon/blog": 371,
	"./frontend_application/footericon/blog.svg": 371,
	"./frontend_application/footericon/facebook": 372,
	"./frontend_application/footericon/facebook.svg": 372,
	"./frontend_application/footericon/instagram": 373,
	"./frontend_application/footericon/instagram.svg": 373,
	"./frontend_application/footericon/linkedin": 374,
	"./frontend_application/footericon/linkedin.svg": 374,
	"./frontend_application/footericon/mailto": 375,
	"./frontend_application/footericon/mailto.svg": 375,
	"./frontend_application/footericon/pinterest": 376,
	"./frontend_application/footericon/pinterest.svg": 376,
	"./frontend_application/footericon/telegram": 377,
	"./frontend_application/footericon/telegram.svg": 377,
	"./frontend_application/footericon/tiktok": 378,
	"./frontend_application/footericon/tiktok.svg": 378,
	"./frontend_application/footericon/youtube": 379,
	"./frontend_application/footericon/youtube.svg": 379,
	"./frontend_application/free_trial/banner_img": 380,
	"./frontend_application/free_trial/banner_img.png": 380,
	"./frontend_application/free_trial/calendar": 381,
	"./frontend_application/free_trial/calendar.png": 381,
	"./frontend_application/free_trial/calendar_icon": 382,
	"./frontend_application/free_trial/calendar_icon.png": 382,
	"./frontend_application/free_trial/client": 383,
	"./frontend_application/free_trial/client.png": 383,
	"./frontend_application/free_trial/client_five": 384,
	"./frontend_application/free_trial/client_five.png": 384,
	"./frontend_application/free_trial/client_four": 385,
	"./frontend_application/free_trial/client_four.png": 385,
	"./frontend_application/free_trial/client_one": 386,
	"./frontend_application/free_trial/client_one.png": 386,
	"./frontend_application/free_trial/client_three": 387,
	"./frontend_application/free_trial/client_three.png": 387,
	"./frontend_application/free_trial/client_two": 388,
	"./frontend_application/free_trial/client_two.png": 388,
	"./frontend_application/free_trial/crm": 389,
	"./frontend_application/free_trial/crm.png": 389,
	"./frontend_application/free_trial/crm_icon": 390,
	"./frontend_application/free_trial/crm_icon.png": 390,
	"./frontend_application/free_trial/email": 391,
	"./frontend_application/free_trial/email.png": 391,
	"./frontend_application/free_trial/feature_background": 392,
	"./frontend_application/free_trial/feature_background.png": 392,
	"./frontend_application/free_trial/feature_five": 393,
	"./frontend_application/free_trial/feature_five.png": 393,
	"./frontend_application/free_trial/feature_four": 394,
	"./frontend_application/free_trial/feature_four.png": 394,
	"./frontend_application/free_trial/feature_one": 395,
	"./frontend_application/free_trial/feature_one.png": 395,
	"./frontend_application/free_trial/feature_three": 396,
	"./frontend_application/free_trial/feature_three.png": 396,
	"./frontend_application/free_trial/feature_two": 397,
	"./frontend_application/free_trial/feature_two.png": 397,
	"./frontend_application/free_trial/header_background": 398,
	"./frontend_application/free_trial/header_background.png": 398,
	"./frontend_application/free_trial/heading_banner_blue": 399,
	"./frontend_application/free_trial/heading_banner_blue.png": 399,
	"./frontend_application/free_trial/heading_banner_purple": 400,
	"./frontend_application/free_trial/heading_banner_purple.png": 400,
	"./frontend_application/free_trial/icon-calendar-lg": 401,
	"./frontend_application/free_trial/icon-calendar-lg.png": 401,
	"./frontend_application/free_trial/icon-crm-lg": 402,
	"./frontend_application/free_trial/icon-crm-lg.png": 402,
	"./frontend_application/free_trial/icon-marketing-lg": 403,
	"./frontend_application/free_trial/icon-marketing-lg.png": 403,
	"./frontend_application/free_trial/icon-payment-lg": 404,
	"./frontend_application/free_trial/icon-payment-lg.png": 404,
	"./frontend_application/free_trial/icon-stats-lg": 405,
	"./frontend_application/free_trial/icon-stats-lg.png": 405,
	"./frontend_application/free_trial/icon-venue-lg": 406,
	"./frontend_application/free_trial/icon-venue-lg.png": 406,
	"./frontend_application/free_trial/integrated_icon": 407,
	"./frontend_application/free_trial/integrated_icon.png": 407,
	"./frontend_application/free_trial/payment": 408,
	"./frontend_application/free_trial/payment.png": 408,
	"./frontend_application/free_trial/payment_icon": 409,
	"./frontend_application/free_trial/payment_icon.png": 409,
	"./frontend_application/free_trial/psg_one": 410,
	"./frontend_application/free_trial/psg_one.png": 410,
	"./frontend_application/free_trial/psg_two": 411,
	"./frontend_application/free_trial/psg_two.png": 411,
	"./frontend_application/free_trial/quote_img": 412,
	"./frontend_application/free_trial/quote_img.png": 412,
	"./frontend_application/free_trial/report": 413,
	"./frontend_application/free_trial/report.png": 413,
	"./frontend_application/free_trial/report_icon": 414,
	"./frontend_application/free_trial/report_icon.png": 414,
	"./frontend_application/free_trial/room_icon": 415,
	"./frontend_application/free_trial/room_icon.png": 415,
	"./frontend_application/free_trial/service_one": 416,
	"./frontend_application/free_trial/service_one.png": 416,
	"./frontend_application/free_trial/service_three": 417,
	"./frontend_application/free_trial/service_three.png": 417,
	"./frontend_application/free_trial/service_two": 418,
	"./frontend_application/free_trial/service_two.png": 418,
	"./frontend_application/free_trial/venue": 419,
	"./frontend_application/free_trial/venue.png": 419,
	"./frontend_application/free_trial/venuerific_logo": 420,
	"./frontend_application/free_trial/venuerific_logo.png": 420,
	"./frontend_application/good_bye": 421,
	"./frontend_application/good_bye.png": 421,
	"./frontend_application/help/bg-help": 422,
	"./frontend_application/help/bg-help.png": 422,
	"./frontend_application/homepage_reward_desktop": 423,
	"./frontend_application/homepage_reward_desktop.png": 423,
	"./frontend_application/homepage_reward_mobile": 424,
	"./frontend_application/homepage_reward_mobile.png": 424,
	"./frontend_application/img-banner": 425,
	"./frontend_application/img-banner.png": 425,
	"./frontend_application/img-icon": 426,
	"./frontend_application/img-icon.png": 426,
	"./frontend_application/landing-faq": 50,
	"./frontend_application/landing-faq.png": 50,
	"./frontend_application/landing-faq.webp": 886,
	"./frontend_application/laptop": 51,
	"./frontend_application/laptop.png": 51,
	"./frontend_application/laptop.webp": 887,
	"./frontend_application/logo-footer": 427,
	"./frontend_application/logo-footer.png": 427,
	"./frontend_application/logs-blank": 428,
	"./frontend_application/logs-blank.png": 428,
	"./frontend_application/map/hongkong": 429,
	"./frontend_application/map/hongkong.webp": 429,
	"./frontend_application/map/indonesia": 430,
	"./frontend_application/map/indonesia.webp": 430,
	"./frontend_application/map/malaysia": 431,
	"./frontend_application/map/malaysia.webp": 431,
	"./frontend_application/map/philippines": 432,
	"./frontend_application/map/philippines.webp": 432,
	"./frontend_application/map/singapore": 433,
	"./frontend_application/map/singapore.webp": 433,
	"./frontend_application/master_card": 52,
	"./frontend_application/master_card.png": 52,
	"./frontend_application/master_card.svg": 888,
	"./frontend_application/multi-data-icon": 434,
	"./frontend_application/multi-data-icon.png": 434,
	"./frontend_application/myfavourite-blank": 435,
	"./frontend_application/myfavourite-blank.png": 435,
	"./frontend_application/myhosting/call": 436,
	"./frontend_application/myhosting/call.png": 436,
	"./frontend_application/myhosting/completed": 437,
	"./frontend_application/myhosting/completed.png": 437,
	"./frontend_application/myhosting/email": 438,
	"./frontend_application/myhosting/email.png": 438,
	"./frontend_application/myhosting/paid": 439,
	"./frontend_application/myhosting/paid.png": 439,
	"./frontend_application/myhosting/pending": 440,
	"./frontend_application/myhosting/pending.png": 440,
	"./frontend_application/myhosting/quote_required": 441,
	"./frontend_application/myhosting/quote_required.png": 441,
	"./frontend_application/myhosting/rejected": 442,
	"./frontend_application/myhosting/rejected.png": 442,
	"./frontend_application/myhosting/reviewed": 443,
	"./frontend_application/myhosting/reviewed.png": 443,
	"./frontend_application/myhosting/scheduled": 444,
	"./frontend_application/myhosting/scheduled.png": 444,
	"./frontend_application/myhosting/site_visit": 445,
	"./frontend_application/myhosting/site_visit.png": 445,
	"./frontend_application/myhosting/unpaid": 446,
	"./frontend_application/myhosting/unpaid.png": 446,
	"./frontend_application/myhosting/urgent_request": 447,
	"./frontend_application/myhosting/urgent_request.png": 447,
	"./frontend_application/myhosting/whatsapp": 448,
	"./frontend_application/myhosting/whatsapp.png": 448,
	"./frontend_application/myinvitation-blank": 449,
	"./frontend_application/myinvitation-blank.png": 449,
	"./frontend_application/nav-logo": 450,
	"./frontend_application/nav-logo-christmas": 451,
	"./frontend_application/nav-logo-christmas.png": 451,
	"./frontend_application/nav-logo-white": 452,
	"./frontend_application/nav-logo-white-christmas": 453,
	"./frontend_application/nav-logo-white-christmas.png": 453,
	"./frontend_application/nav-logo-white.png": 452,
	"./frontend_application/nav-logo.png": 450,
	"./frontend_application/navicon/black-fav-icon": 454,
	"./frontend_application/navicon/black-fav-icon.svg": 454,
	"./frontend_application/navicon/black-notif-icon": 455,
	"./frontend_application/navicon/black-notif-icon.svg": 455,
	"./frontend_application/navicon/white-fav-icon": 456,
	"./frontend_application/navicon/white-fav-icon.svg": 456,
	"./frontend_application/navicon/white-notif-icon": 457,
	"./frontend_application/navicon/white-notif-icon.svg": 457,
	"./frontend_application/news-placeholder": 458,
	"./frontend_application/news-placeholder.svg": 458,
	"./frontend_application/no-photo-venue": 459,
	"./frontend_application/no-photo-venue.jpg": 459,
	"./frontend_application/nogroup": 460,
	"./frontend_application/nogroup.png": 460,
	"./frontend_application/noinquiries": 461,
	"./frontend_application/noinquiries.png": 461,
	"./frontend_application/noroom": 462,
	"./frontend_application/noroom.png": 462,
	"./frontend_application/notification/event_planner/enquiry_accepted": 463,
	"./frontend_application/notification/event_planner/enquiry_accepted.png": 463,
	"./frontend_application/notification/event_planner/enquiry_declined": 464,
	"./frontend_application/notification/event_planner/enquiry_declined.png": 464,
	"./frontend_application/notification/event_planner/enquiry_read": 465,
	"./frontend_application/notification/event_planner/enquiry_read.png": 465,
	"./frontend_application/notification/event_planner/enquiry_sent": 466,
	"./frontend_application/notification/event_planner/enquiry_sent.png": 466,
	"./frontend_application/notification/event_planner/event_finished": 467,
	"./frontend_application/notification/event_planner/event_finished.png": 467,
	"./frontend_application/notification/event_planner/invoice_sent": 468,
	"./frontend_application/notification/event_planner/invoice_sent.png": 468,
	"./frontend_application/notification/event_planner/news_created": 469,
	"./frontend_application/notification/event_planner/news_created.png": 469,
	"./frontend_application/notification/event_planner/profile_incomplete": 470,
	"./frontend_application/notification/event_planner/profile_incomplete.png": 470,
	"./frontend_application/notification/venue_owner/call_missed": 471,
	"./frontend_application/notification/venue_owner/call_missed.png": 471,
	"./frontend_application/notification/venue_owner/enquiry_accepted": 472,
	"./frontend_application/notification/venue_owner/enquiry_accepted.png": 472,
	"./frontend_application/notification/venue_owner/enquiry_sent": 473,
	"./frontend_application/notification/venue_owner/enquiry_sent.png": 473,
	"./frontend_application/notification/venue_owner/enquiry_unread": 474,
	"./frontend_application/notification/venue_owner/enquiry_unread.png": 474,
	"./frontend_application/notification/venue_owner/event_finished": 475,
	"./frontend_application/notification/venue_owner/event_finished.png": 475,
	"./frontend_application/notification/venue_owner/goal_empty": 476,
	"./frontend_application/notification/venue_owner/goal_empty.png": 476,
	"./frontend_application/notification/venue_owner/goal_unmet": 477,
	"./frontend_application/notification/venue_owner/goal_unmet.png": 477,
	"./frontend_application/notification/venue_owner/payment_submitted": 478,
	"./frontend_application/notification/venue_owner/payment_submitted.png": 478,
	"./frontend_application/notification/venue_owner/profile_missing_phone_number": 479,
	"./frontend_application/notification/venue_owner/profile_missing_phone_number.png": 479,
	"./frontend_application/notification/venue_owner/profile_missing_picture": 480,
	"./frontend_application/notification/venue_owner/profile_missing_picture.png": 480,
	"./frontend_application/notification/venue_owner/promotion_empty": 481,
	"./frontend_application/notification/venue_owner/promotion_empty.png": 481,
	"./frontend_application/notification/venue_owner/review_received": 482,
	"./frontend_application/notification/venue_owner/review_received.png": 482,
	"./frontend_application/notification/venue_owner/stats_summarized": 483,
	"./frontend_application/notification/venue_owner/stats_summarized.png": 483,
	"./frontend_application/nouser_placeholder": 484,
	"./frontend_application/nouser_placeholder.svg": 484,
	"./frontend_application/package-icon": 485,
	"./frontend_application/package-icon.svg": 485,
	"./frontend_application/paper-icon": 486,
	"./frontend_application/paper-icon.svg": 486,
	"./frontend_application/payment-icon": 487,
	"./frontend_application/payment-icon.png": 487,
	"./frontend_application/profile_completed_icon": 488,
	"./frontend_application/profile_completed_icon.svg": 488,
	"./frontend_application/promo-badge": 489,
	"./frontend_application/promo-badge.png": 489,
	"./frontend_application/promo-banner-md": 490,
	"./frontend_application/promo-banner-md.png": 490,
	"./frontend_application/promo-banner-sm": 491,
	"./frontend_application/promo-banner-sm.png": 491,
	"./frontend_application/promo-blank": 492,
	"./frontend_application/promo-blank.png": 492,
	"./frontend_application/promo-icon": 493,
	"./frontend_application/promo-icon.png": 493,
	"./frontend_application/question": 494,
	"./frontend_application/question.png": 494,
	"./frontend_application/review-blank": 495,
	"./frontend_application/review-blank.png": 495,
	"./frontend_application/reward-icon": 496,
	"./frontend_application/reward-icon-lg": 497,
	"./frontend_application/reward-icon-lg.png": 497,
	"./frontend_application/reward-icon.png": 496,
	"./frontend_application/reward_bg": 498,
	"./frontend_application/reward_bg.png": 498,
	"./frontend_application/reward_img": 499,
	"./frontend_application/reward_img.jpg": 499,
	"./frontend_application/sad": 500,
	"./frontend_application/sad.png": 500,
	"./frontend_application/single-data-icon": 501,
	"./frontend_application/single-data-icon.png": 501,
	"./frontend_application/snap": 502,
	"./frontend_application/snap.png": 502,
	"./frontend_application/solution/venuerificpay": 503,
	"./frontend_application/solution/venuerificpay.jpg": 503,
	"./frontend_application/solution/videoprod": 504,
	"./frontend_application/solution/videoprod.jpg": 504,
	"./frontend_application/solution/virtualwedding": 505,
	"./frontend_application/solution/virtualwedding.jpg": 505,
	"./frontend_application/star": 506,
	"./frontend_application/star.png": 506,
	"./frontend_application/stats/icon-bounced": 507,
	"./frontend_application/stats/icon-bounced.png": 507,
	"./frontend_application/stats/icon-clicked": 508,
	"./frontend_application/stats/icon-clicked.png": 508,
	"./frontend_application/stats/icon-clock": 509,
	"./frontend_application/stats/icon-clock.png": 509,
	"./frontend_application/stats/icon-opened": 510,
	"./frontend_application/stats/icon-opened.png": 510,
	"./frontend_application/stats/icon-park_ranking": 511,
	"./frontend_application/stats/icon-park_ranking.png": 511,
	"./frontend_application/stats/icon-send-check": 512,
	"./frontend_application/stats/icon-send-check.png": 512,
	"./frontend_application/stats/icon-unsubscribed": 513,
	"./frontend_application/stats/icon-unsubscribed.png": 513,
	"./frontend_application/stripe-gray-img": 514,
	"./frontend_application/stripe-gray-img.svg": 514,
	"./frontend_application/stripe-img": 515,
	"./frontend_application/stripe-img.png": 515,
	"./frontend_application/subpupgrade": 516,
	"./frontend_application/subpupgrade.png": 516,
	"./frontend_application/three-sixty-icon-sm": 517,
	"./frontend_application/three-sixty-icon-sm.png": 517,
	"./frontend_application/thumb": 518,
	"./frontend_application/thumb.png": 518,
	"./frontend_application/todo-empty": 519,
	"./frontend_application/todo-empty.png": 519,
	"./frontend_application/up-icon": 520,
	"./frontend_application/up-icon.svg": 520,
	"./frontend_application/upload-icon": 521,
	"./frontend_application/upload-icon.jpg": 521,
	"./frontend_application/upload-placeholder": 522,
	"./frontend_application/upload-placeholder.svg": 522,
	"./frontend_application/usernav": 523,
	"./frontend_application/usernav.png": 523,
	"./frontend_application/vca-award-badge": 524,
	"./frontend_application/vca-award-badge.gif": 524,
	"./frontend_application/venue/account-grey": 525,
	"./frontend_application/venue/account-grey.png": 525,
	"./frontend_application/venue/account-img": 526,
	"./frontend_application/venue/account-img.png": 526,
	"./frontend_application/venue/air-conditioning-icon": 527,
	"./frontend_application/venue/air-conditioning-icon.png": 527,
	"./frontend_application/venue/amp-icon": 528,
	"./frontend_application/venue/amp-icon.png": 528,
	"./frontend_application/venue/availability-icon": 529,
	"./frontend_application/venue/availability-icon.png": 529,
	"./frontend_application/venue/bar-icon": 530,
	"./frontend_application/venue/bar-icon.png": 530,
	"./frontend_application/venue/bar-tab-icon": 531,
	"./frontend_application/venue/bar-tab-icon.png": 531,
	"./frontend_application/venue/board-games-icon": 532,
	"./frontend_application/venue/board-games-icon.png": 532,
	"./frontend_application/venue/books-icon": 533,
	"./frontend_application/venue/books-icon.png": 533,
	"./frontend_application/venue/bring-your-own-stuff-icon": 534,
	"./frontend_application/venue/bring-your-own-stuff-icon.png": 534,
	"./frontend_application/venue/bus-stop-icon": 535,
	"./frontend_application/venue/bus-stop-icon.png": 535,
	"./frontend_application/venue/car-park-icon": 536,
	"./frontend_application/venue/car-park-icon.png": 536,
	"./frontend_application/venue/card-games-icon": 537,
	"./frontend_application/venue/card-games-icon.png": 537,
	"./frontend_application/venue/catering-icon": 538,
	"./frontend_application/venue/catering-icon.png": 538,
	"./frontend_application/venue/chairs-icon": 539,
	"./frontend_application/venue/chairs-icon.png": 539,
	"./frontend_application/venue/cleaner-icon": 540,
	"./frontend_application/venue/cleaner-icon.png": 540,
	"./frontend_application/venue/coffee-icon": 541,
	"./frontend_application/venue/coffee-icon.png": 541,
	"./frontend_application/venue/custom-accesibility-icon": 542,
	"./frontend_application/venue/custom-accesibility-icon.png": 542,
	"./frontend_application/venue/darts-icon": 543,
	"./frontend_application/venue/darts-icon.png": 543,
	"./frontend_application/venue/discount-icon": 544,
	"./frontend_application/venue/discount-icon.png": 544,
	"./frontend_application/venue/dj-console-icon": 545,
	"./frontend_application/venue/dj-console-icon.png": 545,
	"./frontend_application/venue/email-icon": 546,
	"./frontend_application/venue/email-icon.png": 546,
	"./frontend_application/venue/enquiry-white-icon": 547,
	"./frontend_application/venue/enquiry-white-icon.png": 547,
	"./frontend_application/venue/event-staff-icon": 548,
	"./frontend_application/venue/event-staff-icon.png": 548,
	"./frontend_application/venue/exclamation-icon": 549,
	"./frontend_application/venue/exclamation-icon.png": 549,
	"./frontend_application/venue/fb-icon": 550,
	"./frontend_application/venue/fb-icon.png": 550,
	"./frontend_application/venue/food-icon": 551,
	"./frontend_application/venue/food-icon.png": 551,
	"./frontend_application/venue/full-bar-icon": 552,
	"./frontend_application/venue/full-bar-icon.png": 552,
	"./frontend_application/venue/games-icon": 553,
	"./frontend_application/venue/games-icon.png": 553,
	"./frontend_application/venue/karaoke-machine-icon": 554,
	"./frontend_application/venue/karaoke-machine-icon.png": 554,
	"./frontend_application/venue/linkedin-icon": 555,
	"./frontend_application/venue/linkedin-icon.png": 555,
	"./frontend_application/venue/microphone-icon": 556,
	"./frontend_application/venue/microphone-icon.png": 556,
	"./frontend_application/venue/nearby-mrt-icon": 557,
	"./frontend_application/venue/nearby-mrt-icon.png": 557,
	"./frontend_application/venue/offer-icon": 558,
	"./frontend_application/venue/offer-icon.png": 558,
	"./frontend_application/venue/other-amenities-icon": 559,
	"./frontend_application/venue/other-amenities-icon.png": 559,
	"./frontend_application/venue/package-deals-icon": 560,
	"./frontend_application/venue/package-deals-icon.png": 560,
	"./frontend_application/venue/package-icon": 561,
	"./frontend_application/venue/package-icon.png": 561,
	"./frontend_application/venue/papers-icon": 562,
	"./frontend_application/venue/papers-icon.png": 562,
	"./frontend_application/venue/pens-icon": 563,
	"./frontend_application/venue/pens-icon.png": 563,
	"./frontend_application/venue/ping-pong-table-icon": 564,
	"./frontend_application/venue/ping-pong-table-icon.png": 564,
	"./frontend_application/venue/pool-table-icon": 565,
	"./frontend_application/venue/pool-table-icon.png": 565,
	"./frontend_application/venue/private-room-icon": 566,
	"./frontend_application/venue/private-room-icon.png": 566,
	"./frontend_application/venue/projector-icon": 567,
	"./frontend_application/venue/projector-icon.png": 567,
	"./frontend_application/venue/restaurant-icon": 568,
	"./frontend_application/venue/restaurant-icon.png": 568,
	"./frontend_application/venue/room-icon": 569,
	"./frontend_application/venue/room-icon.png": 569,
	"./frontend_application/venue/rules-icon": 570,
	"./frontend_application/venue/rules-icon.png": 570,
	"./frontend_application/venue/seats-icon": 571,
	"./frontend_application/venue/seats-icon.png": 571,
	"./frontend_application/venue/size-icon": 572,
	"./frontend_application/venue/size-icon.png": 572,
	"./frontend_application/venue/smoking-area-icon": 573,
	"./frontend_application/venue/smoking-area-icon.png": 573,
	"./frontend_application/venue/sound-system-icon": 574,
	"./frontend_application/venue/sound-system-icon.png": 574,
	"./frontend_application/venue/stage-icon": 575,
	"./frontend_application/venue/stage-icon.png": 575,
	"./frontend_application/venue/standing-icon": 576,
	"./frontend_application/venue/standing-icon.png": 576,
	"./frontend_application/venue/street-parking-icon": 577,
	"./frontend_application/venue/street-parking-icon.png": 577,
	"./frontend_application/venue/swimming-pool-icon": 578,
	"./frontend_application/venue/swimming-pool-icon.png": 578,
	"./frontend_application/venue/tables-icon": 579,
	"./frontend_application/venue/tables-icon.png": 579,
	"./frontend_application/venue/taxi-stand-icon": 580,
	"./frontend_application/venue/taxi-stand-icon.png": 580,
	"./frontend_application/venue/tea-icon": 581,
	"./frontend_application/venue/tea-icon.png": 581,
	"./frontend_application/venue/tech-support-icon": 582,
	"./frontend_application/venue/tech-support-icon.png": 582,
	"./frontend_application/venue/tv-screen-icon": 583,
	"./frontend_application/venue/tv-screen-icon.png": 583,
	"./frontend_application/venue/twitter-icon": 584,
	"./frontend_application/venue/twitter-icon.png": 584,
	"./frontend_application/venue/valet-service-icon": 585,
	"./frontend_application/venue/valet-service-icon.png": 585,
	"./frontend_application/venue/venue-img-five": 586,
	"./frontend_application/venue/venue-img-five.jpg": 586,
	"./frontend_application/venue/venue-img-four": 587,
	"./frontend_application/venue/venue-img-four.jpg": 587,
	"./frontend_application/venue/venue-img-one": 588,
	"./frontend_application/venue/venue-img-one.jpg": 588,
	"./frontend_application/venue/venue-img-three": 589,
	"./frontend_application/venue/venue-img-three.jpg": 589,
	"./frontend_application/venue/venue-img-two": 590,
	"./frontend_application/venue/venue-img-two.jpg": 590,
	"./frontend_application/venue/whatsapp-icon": 591,
	"./frontend_application/venue/whatsapp-icon.png": 591,
	"./frontend_application/venue/whatsapp-lg-icon": 592,
	"./frontend_application/venue/whatsapp-lg-icon.png": 592,
	"./frontend_application/venue/whatsapp-white-icon": 593,
	"./frontend_application/venue/whatsapp-white-icon.png": 593,
	"./frontend_application/venue/white-board-icon": 594,
	"./frontend_application/venue/white-board-icon.png": 594,
	"./frontend_application/venue/wifi-icon": 595,
	"./frontend_application/venue/wifi-icon.png": 595,
	"./frontend_application/video-icon": 596,
	"./frontend_application/video-icon-sm": 597,
	"./frontend_application/video-icon-sm.png": 597,
	"./frontend_application/video-icon.png": 596,
	"./frontend_application/visa": 53,
	"./frontend_application/visa.png": 53,
	"./frontend_application/visa.svg": 889,
	"./frontend_application/vnfc-bank-logo": 598,
	"./frontend_application/vnfc-bank-logo.svg": 598,
	"./frontend_application/vnfc-new-pay-logo": 599,
	"./frontend_application/vnfc-new-pay-logo.svg": 599,
	"./frontend_application/vnfc-pay-logo": 600,
	"./frontend_application/vnfc-pay-logo.png": 600,
	"./google-icon": 601,
	"./google-icon.png": 601,
	"./hk": 602,
	"./hk.png": 602,
	"./home/banner_flashdeal": 603,
	"./home/banner_flashdeal.png": 603,
	"./home/btn_next": 604,
	"./home/btn_next.png": 604,
	"./home/btn_prev": 605,
	"./home/btn_prev.png": 605,
	"./home/img_baby-shower": 606,
	"./home/img_baby-shower.png": 606,
	"./home/img_badge": 607,
	"./home/img_badge.png": 607,
	"./home/img_birthday-party": 608,
	"./home/img_birthday-party.png": 608,
	"./home/img_company-dinner-and-dance": 609,
	"./home/img_company-dinner-and-dance.png": 609,
	"./home/img_corporate-seminar": 610,
	"./home/img_corporate-seminar.png": 610,
	"./home/img_meeting": 611,
	"./home/img_meeting.png": 611,
	"./home/img_thumb-1": 612,
	"./home/img_thumb-1.png": 612,
	"./home/img_thumb-2": 613,
	"./home/img_thumb-2.png": 613,
	"./home/img_thumb-3": 614,
	"./home/img_thumb-3.png": 614,
	"./home/img_wedding": 615,
	"./home/img_wedding.png": 615,
	"./icon1": 616,
	"./icon1.svg": 616,
	"./icon2": 617,
	"./icon2.svg": 617,
	"./icon3": 618,
	"./icon3.svg": 618,
	"./icons/chevron-left-circle": 619,
	"./icons/chevron-left-circle.png": 619,
	"./icons/favourite": 620,
	"./icons/favourite.png": 620,
	"./icons/my_venues": 621,
	"./icons/my_venues.png": 621,
	"./icons/venue_group": 622,
	"./icons/venue_group.png": 622,
	"./id": 623,
	"./id.png": 623,
	"./img-icon": 624,
	"./img-icon.png": 624,
	"./jewel": 625,
	"./jewel.png": 625,
	"./linkedin-icon": 626,
	"./linkedin-icon.png": 626,
	"./logo": 627,
	"./logo-christmas": 628,
	"./logo-christmas.png": 628,
	"./logo.png": 627,
	"./millennium": 629,
	"./millennium.png": 629,
	"./mox": 630,
	"./mox.png": 630,
	"./my": 631,
	"./my.png": 631,
	"./new-assets/emoji/party": 632,
	"./new-assets/emoji/party.png": 632,
	"./new-assets/promo-badge": 633,
	"./new-assets/promo-badge.png": 633,
	"./new-assets/user": 634,
	"./new-assets/user.png": 634,
	"./pasarbella": 635,
	"./pasarbella.png": 635,
	"./payments/calendar-icon": 636,
	"./payments/calendar-icon.svg": 636,
	"./payments/card-gray-icon": 637,
	"./payments/card-gray-icon.png": 637,
	"./payments/card-icon": 638,
	"./payments/card-icon.svg": 638,
	"./payments/credit-card": 639,
	"./payments/credit-card.jpg": 639,
	"./payments/dashboard": 640,
	"./payments/dashboard.png": 640,
	"./payments/header": 641,
	"./payments/header-mobile": 642,
	"./payments/header-mobile.jpg": 642,
	"./payments/header.jpg": 641,
	"./payments/logo": 643,
	"./payments/logo.svg": 643,
	"./payments/monitor-icon": 644,
	"./payments/monitor-icon.svg": 644,
	"./payments/payment-illustration-1": 645,
	"./payments/payment-illustration-1.svg": 645,
	"./payments/payment-illustration-2": 646,
	"./payments/payment-illustration-2.svg": 646,
	"./payments/payment-illustration-3": 647,
	"./payments/payment-illustration-3.svg": 647,
	"./payments/payment-wrapper": 648,
	"./payments/payment-wrapper.svg": 648,
	"./payments/seamless": 649,
	"./payments/seamless.jpg": 649,
	"./payments/sites": 650,
	"./payments/sites.svg": 650,
	"./payments/web-icon": 651,
	"./payments/web-icon.svg": 651,
	"./ph": 652,
	"./ph.png": 652,
	"./private-venue/1": 653,
	"./private-venue/1.png": 653,
	"./private-venue/2": 654,
	"./private-venue/2.png": 654,
	"./private-venue/banner-main": 655,
	"./private-venue/banner-main.png": 655,
	"./private-venue/bg-benefit": 656,
	"./private-venue/bg-benefit.png": 656,
	"./private-venue/bg-cta": 657,
	"./private-venue/bg-cta.png": 657,
	"./private-venue/bg-hover-cheers": 658,
	"./private-venue/bg-hover-cheers.png": 658,
	"./private-venue/bg-hover-home": 659,
	"./private-venue/bg-hover-home.png": 659,
	"./private-venue/bg-hover-unique": 660,
	"./private-venue/bg-hover-unique.png": 660,
	"./private-venue/bg-hover-work": 661,
	"./private-venue/bg-hover-work.png": 661,
	"./private-venue/bg-stats": 662,
	"./private-venue/bg-stats.png": 662,
	"./private-venue/bridge": 663,
	"./private-venue/bridge.png": 663,
	"./private-venue/calendar": 664,
	"./private-venue/calendar.svg": 664,
	"./private-venue/chart": 665,
	"./private-venue/chart.svg": 665,
	"./private-venue/cheers": 666,
	"./private-venue/cheers.svg": 666,
	"./private-venue/csc": 667,
	"./private-venue/csc.png": 667,
	"./private-venue/distrii": 668,
	"./private-venue/distrii.png": 668,
	"./private-venue/experience": 669,
	"./private-venue/experience.svg": 669,
	"./private-venue/hover-cheers": 670,
	"./private-venue/hover-cheers.svg": 670,
	"./private-venue/hover-private": 671,
	"./private-venue/hover-private.svg": 671,
	"./private-venue/hover-unique": 672,
	"./private-venue/hover-unique.svg": 672,
	"./private-venue/hover-work": 673,
	"./private-venue/hover-work.svg": 673,
	"./private-venue/location": 674,
	"./private-venue/location.png": 674,
	"./private-venue/partnership": 675,
	"./private-venue/partnership.png": 675,
	"./private-venue/pin": 676,
	"./private-venue/pin.svg": 676,
	"./private-venue/private": 677,
	"./private-venue/private.svg": 677,
	"./private-venue/professional": 678,
	"./private-venue/professional.svg": 678,
	"./private-venue/trust": 679,
	"./private-venue/trust.svg": 679,
	"./private-venue/unique": 680,
	"./private-venue/unique.svg": 680,
	"./private-venue/wework": 681,
	"./private-venue/wework.png": 681,
	"./private-venue/work": 682,
	"./private-venue/work.svg": 682,
	"./responsive-icon": 683,
	"./responsive-icon.png": 683,
	"./room-icon": 684,
	"./room-icon.png": 684,
	"./search/bg_search_activities": 685,
	"./search/bg_search_activities.png": 685,
	"./search/yellow_buildings": 686,
	"./search/yellow_buildings.png": 686,
	"./sg": 687,
	"./sg.png": 687,
	"./skills-future-logo": 688,
	"./skills-future-logo.png": 688,
	"./slider1": 689,
	"./slider1.jpg": 689,
	"./super-venue/badge-card-supervenue": 690,
	"./super-venue/badge-card-supervenue.svg": 690,
	"./super-venue/badge-venue-supervenue": 691,
	"./super-venue/badge-venue-supervenue.svg": 691,
	"./super-venue/benefits1": 692,
	"./super-venue/benefits1.png": 692,
	"./super-venue/benefits2": 693,
	"./super-venue/benefits2.png": 693,
	"./super-venue/icons/badge": 694,
	"./super-venue/icons/badge.svg": 694,
	"./super-venue/icons/filter": 695,
	"./super-venue/icons/filter.svg": 695,
	"./super-venue/icons/search": 696,
	"./super-venue/icons/search.svg": 696,
	"./super-venue/icons/support": 697,
	"./super-venue/icons/support.svg": 697,
	"./super-venue/myaccount": 698,
	"./super-venue/myaccount.png": 698,
	"./super-venue/supervenue": 699,
	"./super-venue/supervenue.png": 699,
	"./testimg": 700,
	"./testimg.png": 700,
	"./testimonial/aaron_lee_all_to_gather": 701,
	"./testimonial/aaron_lee_all_to_gather.jpg": 701,
	"./testimonial/aliff": 702,
	"./testimonial/aliff.jpeg": 702,
	"./testimonial/chen": 703,
	"./testimonial/chen.jpeg": 703,
	"./testimonial/daniellim_csc": 704,
	"./testimonial/daniellim_csc.png": 704,
	"./testimonial/jonathanpang_distrii": 705,
	"./testimonial/jonathanpang_distrii.png": 705,
	"./testimonial/kanthan_jay_sk_hall": 706,
	"./testimonial/kanthan_jay_sk_hall.jpeg": 706,
	"./testimonial/ophelia": 707,
	"./testimonial/ophelia.jpeg": 707,
	"./testimonial/raymond_howe": 708,
	"./testimonial/raymond_howe.jpeg": 708,
	"./testimonial/ying": 709,
	"./testimonial/ying.png": 709,
	"./th": 710,
	"./th.png": 710,
	"./trophy-icon": 711,
	"./trophy-icon.png": 711,
	"./up-icon": 712,
	"./up-icon-blue": 713,
	"./up-icon-blue.svg": 713,
	"./up-icon.svg": 712,
	"./user_blank": 714,
	"./user_blank.png": 714,
	"./vca/banner-main": 715,
	"./vca/banner-main-2022": 716,
	"./vca/banner-main-2022.png": 716,
	"./vca/banner-main.png": 715,
	"./vca/bg-about": 717,
	"./vca/bg-about-2022": 718,
	"./vca/bg-about-2022.png": 718,
	"./vca/bg-about.png": 717,
	"./vca/bg-cat": 719,
	"./vca/bg-cat.png": 719,
	"./vca/bg-category": 720,
	"./vca/bg-category.png": 720,
	"./vca/bg-category2022": 721,
	"./vca/bg-category2022.png": 721,
	"./vca/bg-howto": 722,
	"./vca/bg-howto-2022": 723,
	"./vca/bg-howto-2022.png": 723,
	"./vca/bg-howto.png": 722,
	"./vca/bg-popup": 724,
	"./vca/bg-popup-2022": 725,
	"./vca/bg-popup-2022.png": 725,
	"./vca/bg-popup-2023": 726,
	"./vca/bg-popup-2023.png": 726,
	"./vca/bg-popup.png": 724,
	"./vca/bg-sponsor": 727,
	"./vca/bg-sponsor-2022": 728,
	"./vca/bg-sponsor-2022.png": 728,
	"./vca/bg-sponsor.old": 729,
	"./vca/bg-sponsor.old.png": 729,
	"./vca/bg-sponsor.png": 727,
	"./vca/categories/cafe": 730,
	"./vca/categories/cafe.png": 730,
	"./vca/categories/innovative": 731,
	"./vca/categories/innovative.png": 731,
	"./vca/categories/intimate": 732,
	"./vca/categories/intimate.png": 732,
	"./vca/categories/popular": 733,
	"./vca/categories/popular.png": 733,
	"./vca/categories/resilient": 734,
	"./vca/categories/resilient.png": 734,
	"./vca/categories/restaurant": 735,
	"./vca/categories/restaurant.png": 735,
	"./vca/categories/risingstar": 736,
	"./vca/categories/risingstar.png": 736,
	"./vca/categories/yacht": 737,
	"./vca/categories/yacht.png": 737,
	"./vca/congrats": 738,
	"./vca/congrats.png": 738,
	"./vca/facebook": 739,
	"./vca/facebook.png": 739,
	"./vca/nome0": 740,
	"./vca/nome0.png": 740,
	"./vca/nome1": 741,
	"./vca/nome1.png": 741,
	"./vca/nome2": 742,
	"./vca/nome2.png": 742,
	"./vca/nome3": 743,
	"./vca/nome3.png": 743,
	"./vca/nome4": 744,
	"./vca/nome4.png": 744,
	"./vca/nome5": 745,
	"./vca/nome5.png": 745,
	"./vca/nomf0": 746,
	"./vca/nomf0.png": 746,
	"./vca/nomf1": 747,
	"./vca/nomf1.png": 747,
	"./vca/nomf2": 748,
	"./vca/nomf2.png": 748,
	"./vca/nomf3": 749,
	"./vca/nomf3.png": 749,
	"./vca/nomf4": 750,
	"./vca/nomf4.png": 750,
	"./vca/nomf5": 751,
	"./vca/nomf5.png": 751,
	"./vca/nomg0": 752,
	"./vca/nomg0.png": 752,
	"./vca/nomg1": 753,
	"./vca/nomg1.png": 753,
	"./vca/nomg2": 754,
	"./vca/nomg2.png": 754,
	"./vca/nomg3": 755,
	"./vca/nomg3.png": 755,
	"./vca/nomg4": 756,
	"./vca/nomg4.png": 756,
	"./vca/nomg5": 757,
	"./vca/nomg5.png": 757,
	"./vca/nomh0": 758,
	"./vca/nomh0.png": 758,
	"./vca/nomh1": 759,
	"./vca/nomh1.png": 759,
	"./vca/nomh2": 760,
	"./vca/nomh2.png": 760,
	"./vca/nomh3": 761,
	"./vca/nomh3.png": 761,
	"./vca/nomh4": 762,
	"./vca/nomh4.png": 762,
	"./vca/nomh5": 763,
	"./vca/nomh5.png": 763,
	"./vca/prizes/anjalichocolat": 764,
	"./vca/prizes/anjalichocolat.png": 764,
	"./vca/prizes/beautehub": 765,
	"./vca/prizes/beautehub.png": 765,
	"./vca/prizes/conspicuousscents": 766,
	"./vca/prizes/conspicuousscents.png": 766,
	"./vca/prizes/feast": 767,
	"./vca/prizes/feast.png": 767,
	"./vca/prizes/human": 768,
	"./vca/prizes/human.png": 768,
	"./vca/prizes/ifly": 769,
	"./vca/prizes/ifly.png": 769,
	"./vca/prizes/motionartspace": 770,
	"./vca/prizes/motionartspace.png": 770,
	"./vca/prizes/onthelist": 771,
	"./vca/prizes/onthelist.png": 771,
	"./vca/prizes/tbakery": 772,
	"./vca/prizes/tbakery.png": 772,
	"./vca/prizes/vrworld": 773,
	"./vca/prizes/vrworld.png": 773,
	"./vca/sponsors/anjalichocolat": 774,
	"./vca/sponsors/anjalichocolat.png": 774,
	"./vca/sponsors/beautehub": 775,
	"./vca/sponsors/beautehub.png": 775,
	"./vca/sponsors/beautenails": 776,
	"./vca/sponsors/beautenails.png": 776,
	"./vca/sponsors/bhmedicalaeshtetics": 777,
	"./vca/sponsors/bhmedicalaeshtetics.png": 777,
	"./vca/sponsors/conspicuousscents": 778,
	"./vca/sponsors/conspicuousscents.png": 778,
	"./vca/sponsors/feast": 779,
	"./vca/sponsors/feast.png": 779,
	"./vca/sponsors/human": 780,
	"./vca/sponsors/human.png": 780,
	"./vca/sponsors/ifly": 781,
	"./vca/sponsors/ifly.png": 781,
	"./vca/sponsors/motionartspace": 782,
	"./vca/sponsors/motionartspace.png": 782,
	"./vca/sponsors/onthelist": 783,
	"./vca/sponsors/onthelist.png": 783,
	"./vca/sponsors/tbakery": 784,
	"./vca/sponsors/tbakery.png": 784,
	"./vca/sponsors/vrworld": 785,
	"./vca/sponsors/vrworld.png": 785,
	"./vca/step1": 786,
	"./vca/step1.png": 786,
	"./vca/step2": 787,
	"./vca/step2.png": 787,
	"./vca/step3": 788,
	"./vca/step3.png": 788,
	"./vca/step4": 789,
	"./vca/step4.png": 789,
	"./vca/trophy": 790,
	"./vca/trophy.png": 790,
	"./vca/vca": 791,
	"./vca/vca-2022": 792,
	"./vca/vca-2022.png": 792,
	"./vca/vca.png": 791,
	"./vca/venuewinner": 793,
	"./vca/venuewinner.png": 793,
	"./vca/whatsapp": 794,
	"./vca/whatsapp.png": 794,
	"./vca/winner1": 795,
	"./vca/winner1.png": 795,
	"./vca/winner2": 796,
	"./vca/winner2.png": 796,
	"./vca/winner3": 797,
	"./vca/winner3.png": 797,
	"./vca/winner4": 798,
	"./vca/winner4.png": 798,
	"./venue-icon": 799,
	"./venue-icon.png": 799,
	"./venue_sample": 800,
	"./venue_sample.png": 800,
	"./video-icon": 801,
	"./video-icon.png": 801,
	"./wedding_success/broadcast": 802,
	"./wedding_success/broadcast.png": 802,
	"./wedding_success/crew": 803,
	"./wedding_success/crew.png": 803,
	"./wedding_success/devices": 804,
	"./wedding_success/devices.png": 804,
	"./wedding_success/room": 805,
	"./wedding_success/room.png": 805,
	"./wedding_success/tvw_logo": 806,
	"./wedding_success/tvw_logo.png": 806,
	"./why-vendor/01": 807,
	"./why-vendor/01.png": 807,
	"./why-vendor/02": 808,
	"./why-vendor/02.png": 808,
	"./why-vendor/03": 809,
	"./why-vendor/03.png": 809,
	"./why-vendor/banner-main": 810,
	"./why-vendor/banner-main.png": 810,
	"./why-vendor/notfound": 811,
	"./why-vendor/notfound.png": 811,
	"./why-vendor/user": 812,
	"./why-vendor/user.svg": 812,
	"./why-vendor/venue": 813,
	"./why-vendor/venue.svg": 813,
	"./why/banner-demo": 814,
	"./why/banner-demo.jpg": 814,
	"./why/banner-main": 815,
	"./why/banner-main.jpg": 815,
	"./why/bg-testi": 816,
	"./why/bg-testi.png": 816,
	"./why/calendar": 817,
	"./why/calendar.png": 817,
	"./why/client1": 818,
	"./why/client1.png": 818,
	"./why/client2": 819,
	"./why/client2.png": 819,
	"./why/crm": 820,
	"./why/crm.png": 820,
	"./why/curated": 821,
	"./why/curated.png": 821,
	"./why/endtoend": 822,
	"./why/endtoend.png": 822,
	"./why/manage": 823,
	"./why/manage.png": 823,
	"./why/payment": 824,
	"./why/payment.png": 824,
	"./why/reporting": 825,
	"./why/reporting.png": 825,
	"./why/room": 826,
	"./why/room.png": 826,
	"./why/setmeeting": 827,
	"./why/setmeeting.png": 827,
	"./why/smartvenue": 828,
	"./why/smartvenue.png": 828,
	"./why/venue": 829,
	"./why/venue.png": 829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 879;